/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GenericClearanceCaseResult {
  Error = 0,
  Success = 1,
  RequestValidationFailed = 2,
  FileNotFound = 3,
  UnknownSender = 4,
  UnknownReceiver = 5,
  InvalidCompany = 6,
  InvalidMainCase = 7,
  InvalidTransitDepartureOffice = 8,
  InvalidTransitDestinationOffice = 9,
  InvalidTransitOffices = 10,
  DeliveryCurrencyNotFound = 11,
  InvoiceCurrencyNotFound = 12,
  InvalidPackageCategory = 13,
  InvalidTransactionType = 14,
  InvalidTransportType = 15,
  UnknownDeclaration = 16,
  CalculationFailed = 17,
  ValidationFailed = 18,
  ClearanceCaseNotFound = 19,
  CaseIsProcessing = 20,
}
